import React, { useState, useEffect } from 'react';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Button,
  HStack,
  VStack,
  Text,
  CloseButton,
  Box,
} from '@chakra-ui/react';
import { FiClock, FiTrash2 } from 'react-icons/fi';
import { getDraftInfo } from '../services/draftService';

/**
 * مكون إشعار المسودة المحفوظة
 * يظهر للمستخدم عند وجود مسودة محفوظة مسبقاً
 */
const DraftNotification = ({ onLoadDraft, onDismiss, onDelete }) => {
  const [draftInfo, setDraftInfo] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const loadDraftInfo = async () => {
      const info = await getDraftInfo();
      if (info) {
        setDraftInfo(info);
        setIsVisible(true);
      }
    };
    
    loadDraftInfo();
  }, []);

  const handleLoadDraft = () => {
    if (onLoadDraft) {
      onLoadDraft();
    }
    setIsVisible(false);
  };

  const handleDeleteDraft = () => {
    setIsVisible(false);
    if (onDelete) {
      // استدعاء دالة الحذف من المكون الأب
      onDelete();
    }
  };



  const handleDismiss = () => {
    setIsVisible(false);
    if (onDismiss) {
      onDismiss();
    }
  };

  const formatLastSaved = (dateString) => {
    if (!dateString) return 'غير معروف';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));
    
    if (diffInHours < 1) {
      const diffInMinutes = Math.floor((now - date) / (1000 * 60));
      return `منذ ${diffInMinutes} دقيقة`;
    } else if (diffInHours < 24) {
      return `منذ ${diffInHours} ساعة`;
    } else {
      const diffInDays = Math.floor(diffInHours / 24);
      return `منذ ${diffInDays} يوم`;
    }
  };

  if (!isVisible || !draftInfo) {
    return null;
  }

  return (
    <Box mb={6}>
      <Alert
        status="info"
        variant="subtle"
        flexDirection="column"
        alignItems="flex-start"
        justifyContent="center"
        textAlign="right"
        borderRadius="lg"
        p={4}
      >
        <HStack w="100%" justify="space-between" mb={2}>
          <HStack>
            <AlertIcon />
            <AlertTitle fontSize="lg">مسودة محفوظة!</AlertTitle>
          </HStack>
          <CloseButton onClick={handleDismiss} />
        </HStack>
        
        <AlertDescription w="100%">
          <VStack align="stretch" spacing={3}>
            <Text>
              لديك مسودة محفوظة من طلب ترشيح سابق. يمكنك استكمال التقديم من حيث توقفت.
            </Text>
            
            <HStack spacing={4} fontSize="sm" color="gray.600">
              <HStack>
                <FiClock />
                <Text>آخر حفظ: {formatLastSaved(draftInfo.lastSaved)}</Text>
              </HStack>
              <Text>•</Text>
              <Text>الخطوة: {draftInfo.currentStep }</Text>
            </HStack>
            
            <VStack align="stretch" spacing={3} fontSize="sm">
              <Text fontWeight="semibold">محتوى المسودة:</Text>
              <HStack spacing={4} wrap="wrap">
                {draftInfo.hasPersonalInfo && (
                  <Text color="green.600">✓ المعلومات الشخصية</Text>
                )}
                {draftInfo.hasNomination && (
                  <Text color="green.600">✓ بيانات الترشيح</Text>
                )}
                <Text color="orange.600">⚠ ستحتاج لإعادة اختيار الملفات</Text>
              </HStack>
              
             
            </VStack>
            
            <HStack spacing={3} pt={2}>
              <Button
                colorScheme="blue"
                size="sm"
                onClick={handleLoadDraft}
              >
                استكمال التقديم
              </Button>
            
              
              <Button
                variant="outline"
                colorScheme="red"
                size="sm"
                leftIcon={<FiTrash2 />}
                onClick={handleDeleteDraft}
              >
                حذف المسودة
              </Button>
            </HStack>
          </VStack>
        </AlertDescription>
      </Alert>
    </Box>
  );
};

export default DraftNotification;
